import { render } from "./HelpCenterComponent.vue?vue&type=template&id=0ec19924"
import script from "./HelpCenterComponent.vue?vue&type=script&lang=js"
export * from "./HelpCenterComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__